import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, withLatestFrom, switchMap, catchError } from 'rxjs/operators';

import { SearchActions } from './search.actions';
import { SearchService } from '../../features/search/services/search.service';
import { RootState } from '../root-state.model';

@Injectable()
export class SearchEffects {
  private actions$ = inject(Actions);
  private readonly store = inject<Store<RootState>>(Store);
  private readonly searchService = inject(SearchService);

  searchEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(SearchActions.Search),
      withLatestFrom(this.store),
      switchMap(([action, store]) => {
        const filter = action.filter.trim();
        return this.searchService.search(filter).pipe(
          map((results) => SearchActions.SearchSuccess({ results })),
          catchError((err) => of(SearchActions.SearchFail({ error: err })))
        );
      })
    )
  );
}
